module.exports = __webpack_public_path__ + "assets/questionApp2.818490a2.svg";